import { VEC_ICON_NAME } from "../../../../components/icons/constants"

export const RECIPIENT_TYPE_TITLE = {
    INDIVIDUAL: "Individual",
    BUSINESS: "Business"
}

export const RECIPIENT_TYPE = [
    { title: RECIPIENT_TYPE_TITLE.INDIVIDUAL, icon: VEC_ICON_NAME.PAYER_TYPE_INDIVIDUAL },
    { title: RECIPIENT_TYPE_TITLE.BUSINESS, icon: VEC_ICON_NAME.PAYER_TYPE_BUSINESS }
]

export const RECIPIENT_TYPES_1042_S_TITLES = {
    NO_US_TIN_BUSINESS: "No U.S TIN Business",
    SSN_ITIN: "SSN/ITIN",
    EIN: "EIN",
    QI_WP_WT_EIN: "QI-EIN, WP-EIN, WT-EIN",
    TIN_REQUIRED_BUT_NOT_PROVIDED: "TIN required but not provided",
    TIN_APPLIED_FOR: "TIN Applied For",
    NO_US_TIN_INDIVIDUAL: "No U.S TIN Individual",
}

export const RECIPIENT_TYPE_1042_S = [
    { title: RECIPIENT_TYPES_1042_S_TITLES.NO_US_TIN_BUSINESS, icon: VEC_ICON_NAME.PAYER_TYPE_INDIVIDUAL, value: "No U.S TIN Business" },
    { title: RECIPIENT_TYPES_1042_S_TITLES.SSN_ITIN, icon: VEC_ICON_NAME.PAYER_TYPE_INDIVIDUAL, value: "SSN" },
    { title: RECIPIENT_TYPES_1042_S_TITLES.EIN, icon: VEC_ICON_NAME.PAYER_TYPE_BUSINESS, value: "EIN" },
    { title: RECIPIENT_TYPES_1042_S_TITLES.QI_WP_WT_EIN, icon: VEC_ICON_NAME.PAYER_TYPE_BUSINESS, value: "QI-EIN" },
    { title: RECIPIENT_TYPES_1042_S_TITLES.TIN_REQUIRED_BUT_NOT_PROVIDED, icon: VEC_ICON_NAME.PAYER_TYPE_BUSINESS, value: "TIN Not Provided" },
    { title: RECIPIENT_TYPES_1042_S_TITLES.TIN_APPLIED_FOR, icon: VEC_ICON_NAME.PAYER_TYPE_BUSINESS, value: "TIN Applied For" },
    { title: RECIPIENT_TYPES_1042_S_TITLES.NO_US_TIN_INDIVIDUAL, icon: VEC_ICON_NAME.PAYER_TYPE_BUSINESS, value: "No U.S TIN individual" },
]

export const RECIPIENT_ID_TYPE = {
    EIN: "EIN",
    SSN: "SSN",
}
